/* LFDY – App Landing Page
   Countdown (Weekly Deal) + Slider-Navigation. Kein Framework, keine
   globalen Variablen; reinitialisiert sich im Theme-Editor. */
(() => {
  const pad = (n) => String(n).padStart(2, '0');
  function fmt(ms) {
    const s = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(s / 86400);
    const hms = `${pad(Math.floor((s % 86400) / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
    return d > 0 ? `${d}D ${hms}` : hms;
  }

  /* Countdown: Termine kommen als Unix-Sekunden aus dem Page-Metafeld.
     Vor dem Start "Next deal in", während der Dauer "Live now", danach ausgeblendet. */
  function initCountdown(el) {
    if (el.dataset.lfdyInit) return;
    el.dataset.lfdyInit = '1';
    const dur = +el.dataset.duration * 36e5;
    const starts = (el.dataset.starts || '').split(',').map((v) => +v * 1000).filter((v) => v > 0).sort((a, b) => a - b);
    const labelEl = el.querySelector('[data-lfdy-countdown-label]');
    const timeEl = el.querySelector('[data-lfdy-countdown-time]');
    let lastLive = null;
    let timer = null;

    const compute = (now) => {
      const live = starts.find((s) => now >= s && now < s + dur);
      if (live !== undefined) return { live: true, target: live + dur };
      const next = starts.find((s) => s > now);
      return next !== undefined ? { live: false, target: next } : null;
    };

    const stop = () => { clearInterval(timer); timer = null; };
    const tick = () => {
      const now = Date.now();
      const r = compute(now);
      if (!r) { el.hidden = true; stop(); return; }
      el.hidden = false;
      if (r.live !== lastLive) {
        el.classList.toggle('is-live', r.live);
        labelEl.textContent = r.live ? el.dataset.labelLive : el.dataset.labelNext;
        lastLive = r.live;
      }
      timeEl.textContent = fmt(r.target - now);
    };
    const start = () => { stop(); tick(); if (!el.hidden) timer = setInterval(tick, 1000); };

    start();
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
  }

  function initSlider(root) {
    if (root.dataset.lfdyInit) return;
    root.dataset.lfdyInit = '1';
    const track = root.querySelector('[data-lfdy-track]');
    const prev = root.querySelector('[data-lfdy-prev]');
    const next = root.querySelector('[data-lfdy-next]');
    const nav = prev.parentElement;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const step = () => {
      const card = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    const go = (dir) => track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });

    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-lfdy-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-lfdy-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  /* Shopify Theme-Editor */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
